import { COOKIE_SETTINGS } from './general';

export const DEV_ERRORS = {
  NOT_INITIALIZED: 'Cookie Manager is not initialized',
  ALREADY_INITIALIZED: 'Cookie Manager is already initialized',
  STORAGE_KEY_IS_REQUIRED: 'storageKey property is required',
  ENVIRONMENT_KEY_IS_REQUIRED: 'environment property is required',
  CONFIG_IS_REQUIRED: (props) => `Provide these properties to the init of Cookie Manager: ${props.join(
    ', '
  )}`,
};

export const EU_COUNTRIES_LIST = [
  'AT',
  'BE',
  'BG',
  'HR',
  'CY',
  'CZ',
  'DK',
  'EE',
  'FI',
  'FR',
  'DE',
  'GR',
  'HU',
  'IE',
  'IT',
  'LV',
  'LT',
  'LU',
  'MT',
  'NL',
  'PL',
  'PT',
  'RO',
  'SK',
  'SI',
  'ES',
  'SE',
];

export const STORAGE_OPTIONS = {
  COOKIES: 'COOKIES',
  LOCAL_STORAGE: 'LOCAL_STORAGE',
};

// TODO: temporally moved to const since this settings is generic for editor, dashboard, crms, etc. Maybe it will be moved to the init later
export const PERSIST_SETTINGS = {
  [COOKIE_SETTINGS.FUNCTIONALITY]: [
    {
      storage: STORAGE_OPTIONS.LOCAL_STORAGE,
      key: 'sidebar',
      defaultValue: true,
      canCreate: true,
      canRemove: true,
    },
    {
      storage: STORAGE_OPTIONS.LOCAL_STORAGE,
      key: 'sp_observers_storage',
      canCreate: true,
      canRemove: true,
    },
  ],
  [COOKIE_SETTINGS.ANALYTICS]: [
    {
      storage: STORAGE_OPTIONS.COOKIES,
      key: '_spAnalyticsId',
      canCreate: false,
      canRemove: true,
    },
    {
      storage: STORAGE_OPTIONS.COOKIES,
      key: '_spAnalyticsIdF',
      canCreate: false,
      canRemove: true,
    },
    {
      storage: STORAGE_OPTIONS.COOKIES,
      key: '_spAnalyticsIdFHash',
      canCreate: false,
      canRemove: true,
    },
    {
      storage: STORAGE_OPTIONS.COOKIES,
      key: '_spAnalyticsIdHash',
      canCreate: false,
      canRemove: true,
    },
  ],
};
